import React from 'react';

interface SigningSuccessProps {
  onDone: () => void;
}

const SigningSuccess: React.FC<SigningSuccessProps> = ({ onDone }) => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.checkCircle}>
          <div style={styles.checkmark} />
        </div>
        <h1 style={styles.title}>All documents signed!</h1>
        <p style={styles.subtitle}>You've completed all required documents.</p>
      </div>

      <div style={styles.bottomArea}>
        <button type="button" style={styles.doneButton} onClick={onDone}>
          Done
        </button>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: '#f9fafb',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 20px',
  },
  checkCircle: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: '#dcfce7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    position: 'relative',
  },
  checkmark: {
    width: 24,
    height: 40,
    borderRight: '4px solid #16a34a',
    borderBottom: '4px solid #16a34a',
    transform: 'rotate(45deg) translate(-4px, -4px)',
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#111827',
    margin: '0 0 8px 0',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: '#6b7280',
    margin: 0,
    textAlign: 'center',
  },
  bottomArea: {
    padding: '16px 20px',
    paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
  },
  doneButton: {
    width: '100%',
    height: 52,
    borderRadius: 12,
    backgroundColor: '#2563eb',
    color: '#ffffff',
    fontSize: 17,
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
  },
};

export default SigningSuccess;
